import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class CampaignService {
  constructor(private commonApiService: CommonApiService) {}

  onCreateCampaign(payload: any) {
    return this.commonApiService.post(APIURL.createNewCampaign, payload);
  }

  getCampaignsList(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.CampaignList, params);
  }

  getCampaignsDetails(campaignId: number) {
    const url = `${APIURL.campaignDetails}/${campaignId}`;
    return this.commonApiService.get(url);
  }

  getCampaignTeamList(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.campaignTeamList, params);
  }

  getCompanyMembers() {
    return this.commonApiService.get(APIURL.campaignCompanyMembers);
  }

  addTeamMembers(payload: {
    campaign_id: number;
    members: { user_id: number; role_id: number }[];
  }) {
    return this.commonApiService.post(APIURL.campaignAddTeamMember, payload);
  }

  removeTeamMember(campaignId: number, userId: number) {
    return this.commonApiService.delete(
      `${APIURL.campaignRemoveTeamMember}?campaign_id=${campaignId}&user_id=${userId}`,
    );
  }

  getCampaignHubStats() {
    return this.commonApiService.get(APIURL.camapaignHubStats);
  }

  deleteCampaign(campaignId: number) {
    return this.commonApiService.delete(APIURL.campaignDelete + campaignId);
  }

  updateVideoTitle(payload: { video_id: string; title: string }) {
    return this.commonApiService.post(APIURL.campaignVideoUpdateTitle, payload);
  }

  deleteCampaignVideo(videoId: string | number) {
    return this.commonApiService.delete(APIURL.campaignVideoDelete + videoId);
  }

  getVideoStages(videoId: string | number) {
    return this.commonApiService.get(APIURL.videoStages + videoId);
  }

  getCampaignVideoAspectRatios(videoId: string | number) {
    const params = this.commonApiService.getParamsFromObj({
      video_id: videoId,
    });
    return this.commonApiService.get(APIURL.campaignVideoAspectRatios, params);
  }

  updateCampaignBudget(payload: any) {
    return this.commonApiService.post(APIURL.updateCampaignBudget, payload);
  }

  updateCampaignSoul(payload) {
    return this.commonApiService.post(APIURL.updateCampaignSoul, payload);
  }

  /** Step A — presigned GCS URLs for Campaign Soul logo/product uploads. */
  getSoulAssetsPresignedUrls(payload: {
    campaign_id: number;
    asset_type: "logo" | "product";
    files: { filename: string; content_type: string }[];
  }) {
    return this.commonApiService.post(
      APIURL.campaignSoulAssetsPresignedUrls,
      payload,
    );
  }

  /**
   * Step C — create library asset + campaign link, or record a skip.
   * Store: `{ campaign_id, asset_type, name?, files:[{key,image_url}] }`
   * Skip: `{ campaign_id, asset_type, skipped: true }`
   */
  completeSoulAssetsUpload(
    payload:
      | {
          campaign_id: number;
          asset_type: "logo" | "product";
          name?: string;
          files: { key: string; image_url: string }[];
          skipped?: false;
        }
      | {
          campaign_id: number;
          asset_type: "logo" | "product";
          skipped: true;
        },
  ) {
    return this.commonApiService.post(
      APIURL.campaignSoulAssetsUploadComplete,
      payload,
    );
  }

  getCampaignBriefPresignedUrls(payload: {
    campaign_id: number;
    filenames: string[];
  }) {
    return this.commonApiService.post(
      APIURL.campaignPresignedBriefUrls,
      payload,
    );
  }

  campaignBriefUploadComplete(payload: {
    campaign_id: number;
    files: {
      filename: string;
      key: string;
      size: number;
    }[];
  }) {
    return this.commonApiService.post(
      APIURL.campaignBriefUploadComplete,
      payload,
    );
  }
}
